export function downloadPDF(title, headers, rows, summary) {
  // Build HTML table for PDF
  const now = new Date().toLocaleString("en-IN");
  const sumHTML = summary ? summary.map(s =>
    '<div style="display:inline-block;margin-right:30px;margin-bottom:10px;"><span style="color:#666;font-size:11px;">' + s.label + '</span><br/><span style="font-size:18px;font-weight:800;color:' + (s.color || "#222") + ';">' + s.value + '</span></div>'
  ).join("") : "";

  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${title}</title>
<style>
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family: 'Segoe UI', Arial, sans-serif; padding: 30px; color: #1a1a2e; background: white; }
  .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 24px; border-bottom: 3px solid #F5A623; padding-bottom: 16px; }
  .logo { font-size: 24px; font-weight: 900; }
  .logo span { color: #F5A623; }
  .meta { text-align: right; font-size: 11px; color: #666; }
  .summary { margin-bottom: 20px; padding: 16px; background: #f8f9fa; border-radius: 8px; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 12px; }
  th { background: #1a1a2e; color: white; padding: 10px 12px; text-align: left; font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px; }
  td { padding: 9px 12px; border-bottom: 1px solid #e2e8f0; }
  tr:nth-child(even) { background: #f8fafc; }
  tr:hover { background: #eef2ff; }
  .amount { font-family: 'Courier New', monospace; font-weight: 700; }
  .green { color: #10B981; }
  .red { color: #EF4444; }
  .footer { margin-top: 30px; padding-top: 12px; border-top: 1px solid #e2e8f0; font-size: 10px; color: #94A3B8; text-align: center; }
  @media print { body { padding: 15px; } }
</style></head><body>
  <div class="header">
    <div><div class="logo">Fin<span>Board</span></div><div style="font-size:12px;color:#64748B;margin-top:4px;">v11.3 — Financial Report</div></div>
    <div class="meta"><div style="font-size:14px;font-weight:700;color:#1a1a2e;margin-bottom:4px;">${title}</div><div>Generated: ${now}</div></div>
  </div>
  ${sumHTML ? '<div class="summary">' + sumHTML + '</div>' : ''}
  <table>
    <thead><tr>${headers.map(h => '<th>' + h + '</th>').join('')}</tr></thead>
    <tbody>${rows.map(r => '<tr>' + r.map((c,i) => '<td' + (typeof c === 'string' && c.startsWith('₹') ? ' class="amount"' : '') + '>' + c + '</td>').join('') + '</tr>').join('')}</tbody>
  </table>
  <div class="footer">FinBoard v11.3 · Confidential Financial Document · ${now}</div>
</body></html>`;

  const blob = new Blob([html], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (win) {
    win.onload = () => {
      setTimeout(() => {
        win.print();
        URL.revokeObjectURL(url);
      }, 500);
    };
  } else {
    // Fallback: download as HTML
    const a = document.createElement("a");
    a.href = url;
    a.download = title.replace(/\s+/g, "_") + ".html";
    a.click();
    URL.revokeObjectURL(url);
  }
}
